<template>
  <div class="feedback">
    <!--导航栏-->
    <header-nav></header-nav>

    <div class="container">
      <div class="feedback-top">
        <div class="feedback-title">意见反馈</div>
        <div class="feedback-tips">提出您的意见，因为您反馈的意见我们才会变得更好！</div>
      </div>

      <div class="form-main">
        <el-form :model="form" :rules="rules" ref="form" label-width="80px" class="demo-ruleForm">
          <el-form-item label="昵称" prop="username">
            <el-input class="form-input" v-model="form.username" placeholder="请输入昵称"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="mobile">
            <el-input class="form-input" v-model="form.mobile" placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="反馈内容" prop="desc">
            <el-input class="form-input" type="textarea" v-model="form.desc" placeholder="请输入反馈内容"></el-input>
          </el-form-item>
          <el-form-item label="上传图片:" prop="images">
            <el-upload
              ref="images"
              :data="uploadData"
              :on-change="btnImgChange"
              :on-success="btnImgSuccess"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :file-list="fileListImages"
              :multiple="true"
              :limit="9"
              :action="API_URL + 'index/ajax/upload'"
              list-type="picture-card"
              accept="image/png, image/jpeg, image/jpg"
            >
              <i class="el-icon-plus" />
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" width="100%" alt="" />
            </el-dialog>
          </el-form-item>
          <div class="btn-style submit-btn" @click="onSubmit">确 认</div>
        </el-form>
      </div>
    </div>
    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav";
import footerBox from "@/components/footerBox";
import { getToken } from "@/api/auth";
import { apiIndexFeedback } from "@/api/api";
export default {
  name: "feedback",
  components: { headerNav, footerBox },
  data() {
    return {
      uploadData: {},
      fileListImages: [],
      uploadFilterUid: [],
      dialogVisible: false,
      dialogImageUrl: "",
      form: {
        username: "",
        mobile: "",
        desc: "",
        images: [],
      },
      rules: {
        username: [{ required: true, message: "请输入您的昵称", trigger: "blur" }],
        mobile: [{ required: true, message: "请输入您的联系方式", trigger: "blur" }],
        desc: [{ required: true, message: "请输入您的反馈内容", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.uploadData = {
      token: getToken(),
    };
  },
  methods: {
    btnImgChange(file, fileList) {
      if (!this.uploadFilterUid.includes(file.uid)) {
        console.log(file);
        this.fileListImages.push(file);
        this.uploadFilterUid.push(file.uid);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(image) {
      this.form.images.forEach((item, index) => {
        if (item === image) {
          this.form.images.splice(index, 1);
        }
      });
    },
    btnImgSuccess(response, file, fileList) {
      this.form.images.push(response.data.url);
    },
    onSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          apiIndexFeedback(this.form).then(res => {
            if (res.code === 0) {
              this.$message.success("反馈成功，感谢您的反馈！");
              this.$refs["form"].resetFields();
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.feedback {
  height: 100vh;
  .container {
    background-color: #ffffff;
    padding: 20px;

    .feedback-top {
      margin-bottom: 20px;

      .feedback-title {
        font-weight: bold;
        color: #000;
        font-size: 18px;
        margin-bottom: 3px;
      }
      .feedback-tips {
        font-size: 12px;
        color: #999999;
      }
    }
    .form-main {
      .form-input {
        width: 300px;
      }
      .submit-btn {
        margin-left: 80px;
      }
    }
  }
}
</style>
<style>
.el-form-item__label {
  color: #000 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/feedback/index.vue